var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleMarket = function SvgGoogleMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 1.002V13.63c0 .44.25.82.615 1L7.83 7.315.618 0C.252.18 0 .562 0 1.002m2.232 13.25 7.886-4.618-1.667-1.69zM12.57 6.43c.262.203.431.524.431.885 0 .355-.164.672-.42.876l-1.674.98-1.833-1.858 1.831-1.858zm-2.453-1.436L2.236.381l6.215 6.303z",
    clipRule: "evenodd"
  })));
};
export default SvgGoogleMarket;